import React from 'react';
import HostRoomScreen from '../../components/HostRoomScreen';

const RapFireRoomType = () => <HostRoomScreen gameId="rap_fire" />;

export default RapFireRoomType;
